<template>
<div class="popup" v-cloak v-show="deleteRemindShow">
    <div class="content" id="deleteRemind">
        <div class="title">
            <span v-if="!payVip">
            <span v-if="unsubscribeShow">{{$t('language.common.unsubscribe')}}</span>
            <span v-if="!unsubscribeShow">{{$t('language.rightTopBanner.deleteAccount')}}</span>
            </span>
            <span v-if="payVip">{{$t('language.common.unsubscribe')}}</span>
            <div class="icon white-close dialog-close" @click="closePage()"></div>
        </div>
        <div class="delete-remind-content">
            <span v-if="!payVip">
            <div v-if="unsubscribeShow">{{$t('language.popup.personalCenter.pleaseUnsubscribe')}}</div>
            <div v-if="!unsubscribeShow">{{$t('language.popup.personalCenter.deletePremium')}}</div>
            </span>
            <div v-if="payVip">{{$t('language.paySystem.deleteSubAccount')}}</div>
            <div class="delete-remind-footer">
                <div v-if="!payVip">
                <div class="unsubscribe-button" v-if="unsubscribeShow">
                    <button style="border-radius: 5Px;" @click="switchOldVersion">{{$t('language.popup.personalCenter.switchOld')}}</button>
                </div>
                <div class="delete-button" v-if="!unsubscribeShow">
                    <button class="delete-remind-one" @click="deleteAccount()">{{$t('language.common.delete')}}</button>
                    <button class="delete-remind-two" @click="closePage()">{{$t('language.common.cancel')}}</button>
                </div>
                </div>
                <div v-if="payVip"  class="remind-bind-delbutton" >
                    <button class="delete-remind-one" @click="unsubAccount()">{{$t('language.common.unsubscribe')}}</button>
                    <button class="delete-remind-two" @click="closePage()">{{$t('language.common.cancel')}}</button>
                </div>
                <div>

                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import commonstate from '@/js/constant.js';
import commonUtils from "@/js/workspace/common_util.js";
export default {
    data: function () {
        return {
            deleteRemindShow: false,
            unsubscribeShow: false,
            payVip:false,
            requestNum:0,
        }
    },
    methods: {
        switchOldVersion() {
            this.deleteRemindShow = false;
            let language = commonUtils.getLocaleTo(localStorage.getItem("locale"));
            var tmp = new Date().getTime();
            window.location.href = commonstate.oldVersionUrl + "/index.jsp?rl=" + language + "&tmp=" + tmp + "#home";
        },
        deleteAccount() {
            this.$parent.$refs.deleteAccount.deleteAccountRequest();
        },
        closePage(){
            this.$parent.$refs.deleteAccount.password=null;
            this.deleteRemindShow=false;
            this.payVip=false;
        },
        unsubAccount(){
            let user=commonUtils.getUser();
            let that = this;
            var subId = user.subscrId;
            if(user.subscrId.indexOf('-')>0){
                subId = user.subscrId.slice(0, user.subscrId.indexOf('-'));
            }
            this.Utils.doSubinquiryPostRequest('get_by_id', { subscriptionId: subId }).then(res => {
                if (res.ResultMessage == 'OK') {
                    //获取最新的purchaseId
                    let purchaseId = that.getNewPurchaseId(res);
                    that.Utils.doSubinquiryPostRequest('get_by_purchaseIdV', { purchaseId: purchaseId }).then(res2 => {
                        //如果请求成功
                        if (res2.ResultMessage == 'OK') {
                            let json = JSON.parse(res2.PurchaseNotification);
                            var action = json.items[0].recurringBilling.cancellationUrl;
                            // let lang = commonUtils.getLocaleTo(localStorage.getItem("locale"));
                            // 创建Form  
                            var form = $('<form></form>');  
                            // 设置属性  
                            form.attr('action', action);  
                            form.attr('method', 'post');  
                            form.attr('target', '_blank');  
                            $(document.body).append(form);  
                            // 提交表单  
                            form.submit();  
                            // 注意return false取消链接的默认动作  
                            that.getUserStatus(user);
                            that.deleteRemindShow=false;
                            return false;  
                        }
                    })
                }
            })
        },
        //获取最新的purchaseId
        getNewPurchaseId(res) {
            let newSub = res.Subscription.Items[0];
                if(res.Subscription.Items.length>1){
                    let sub;
                    for(sub of res.Subscription.Items){
                    //isCurrent为true
                    if(sub.isCurrent){
                        newSub = sub;
                        break;
                    }
                    }
                }
            let newPur = newSub.SubscriptionPurchaseItems[0];
            if(newSub.SubscriptionPurchaseItems.length>1){
                let pur;
                for(pur of newSub.SubscriptionPurchaseItems){
                //id最大
                if(pur.PurchaseId>newPur.PurchaseId){
                    newPur = pur;
                }
                }
            }
            return newPur.PurchaseId;
        },
        getUserStatus(user){///通过获取最新的User判断user是否已经状态改变，如果状态改变则刷新界面
            let oldUser=user;
            let that=this;
            let newUser;
            let oldPassword;
            let t;
            this.Utils.doUserHaveLoginRequest('get', {
                ud: oldUser.id,
                salt: oldUser.salt
            }).then(response => {
                that.requestNum=that.requestNum+1;
                newUser = response.user;
                if(!oldUser.password){
                if(newUser.password){
                delete newUser.password;
                }
                }else{
                oldPassword=oldUser.password;
                }
                that.$store.commit('setPassWord', response.user.password);
                var result =commonUtils.Compare(oldUser, newUser);
                if(that.requestNum==50){//如果请求了20次则取消请求
                    clearTimeout(t);
                    return false;
                }
                if(result!=false){//如果结果是相等则过6秒再进行请求
                t=setTimeout(()=>{
                that.getUserStatus(user);
                },4000);
                }else{//如果用户状态已改变
                clearTimeout(t);
                if(oldPassword){
                    newUser.password=oldPassword;
                }else{
                    delete newUser.password;
                }
                commonUtils.setUserToLocal(newUser);
                commonUtils.setUserCookies(newUser);
                if (that.$parent && that.$parent.$refs.rightContBan) {
                    that.$parent.$refs.rightContBan.email=newUser.email;
                    that.$parent.$refs.rightContBan.usedTraffic = newUser.usedBytes;
                    // if(newUser.vip&&newUser.payLevel>1){
                    //  that.$parent.$refs.rightContBan.usedTraffic = newUser.payUsedTraffic;   
                    // }
                    that.$parent.$refs.rightContBan.totalTraffic = newUser.totalBytes;
                    commonUtils.createPayBtn(newUser, that.$parent.$refs.rightContBan);
                }
                that.user=newUser;
                if (newUser.payLevel <=1) {
                    if (newUser.payType == 'Lifetime') {
                        that.$parent.$refs.leftBanner.menuOptionSelect(901);
                        that.$router.push({name: "addCloud"});
                    }
                }
                const vm = window.vm.$children[0].$refs.routerView.$refs.routView;
                if(vm.dataJson){
                if(vm.morePrivileges){
                vm.getMorePrivilege();
                }else{
                //本页的页面也应该改变
                vm.clickIndex=0;
                vm.$forceUpdate();
                vm.initShowData();
                }
                }
                }
            });
        },
    }
}
</script>

<style>
#deleteRemind {
    width: 510Px;
    height: 190Px;
}

.delete-remind-content {
    width: 100%;
    height: 150Px;
    box-sizing: border-box;
    padding: 20px 15px;
    /*no*/
    font-size: 14px;
    /*no*/
}

.delete-remind-footer {
    height: 35Px;
}

.unsubscribe-button {
    float: right;
    margin-top: 50Px;
}

.delete-button,.remind-bind-delbutton{
    width: 478Px;
    vertical-align: middle;
    display: table-cell;
    overflow: hidden !important;
    white-space: nowrap !important;
    text-align: center;
    position: absolute;
    bottom: 20PX;
}
.delete-remind-one {
    border-radius: 5Px;
    margin-right: 35Px;
    min-width: 110Px;
}

.delete-remind-two,
.delete-remind-two:hover {
    width: 110Px;
    border-radius: 5Px;
    border-radius: 5Px;
    background: #fff;
    color: #5562b4;
    border: 1Px solid #5562b4;
    cursor: pointer;

}
</style>



// WEBPACK FOOTER //
// src/components/popup/personal_center_popups/delete_account_remind_popup.vue